import React, { useEffect, useCallback, useState, useContext } from 'react'

import { pathToPost } from '~/shared/utils'
import { PostGrid, Post } from '~/modules/post/components'
import { Blocker, CTABackground } from '~/shared/components'
import {
  useUpdateUserSettings,
  useUserSettings,
  useAccountCredentials,
} from '~/modules/account/hooks'
import { FloatingMenu } from '~/modules/navigation/components'
import { AppContext } from '~/app/providers/App'
import { withRealtime } from '~/modules/realtime/hoc'
import { SERVICE_DEFAULTS } from '~/app/constants'

import { useAccountContext } from '~/modules/account/context'

import {
  useTrackPageViewed,
  useTrackPostsLoaded,
  useTrackChannelSelected,
} from '~/shared/hooks/tracking'

import {
  useChannels,
  useCurrentChannel,
  useCurrentPost,
} from '~/app/state/hooks'

import {
  ChannelSelector,
  ChannelCounters,
  RefreshButton,
} from '~/modules/channel/components'

import {
  SidebarWrapper,
  SidebarHeader,
  SidebarMessage,
  SidebarContent,
  ContentWrapper,
} from './styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'error' implicitly has an 'any' ty... Remove this comment to see the full error message
const PostPage = ({ error, history, match: { params = {} } }) => {
  const [accessDenied, setAccessDenied] = useState(false)

  // @ts-expect-error TS(2339) FIXME: Property 'onClearFilter' does not exist on type 'u... Remove this comment to see the full error message
  const { onClearFilter } = useContext(AppContext)
  const { checkEngageAccess } = useAccountCredentials()

  const hideMarkAsReadModal = useUpdateUserSettings()
  const trackPageViewed = useTrackPageViewed()
  const trackPostsLoaded = useTrackPostsLoaded()
  const trackChannelSelected = useTrackChannelSelected()

  const account = useAccountContext()

  const { channels, queryChannels } = useChannels()

  const { currentChannel, queryCurrentChannel, mutateCurrentChannel } =
    useCurrentChannel()

  const { userSettings, queryUserSettings } = useUserSettings()

  const { currentPost, queryCurrentPost } = useCurrentPost()

  useEffect(() => {
    // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
    if (!account?.id) return

    if (checkEngageAccess(account)) {
      queryChannels()
      queryUserSettings()
      queryCurrentChannel()
      queryCurrentPost()
    } else {
      setAccessDenied(true)
    }
  }, [account])

  // Selected posts changes -> Change URL.
  useEffect(() => {
    // @ts-expect-error TS(2339) FIXME: Property 'postId' does not exist on type '{}'.
    if (currentPost && currentPost.id !== params.postId) {
      const postPath = pathToPost(currentPost.id, currentChannel?.id)
      history.push(postPath)

      trackPageViewed({
        url: '/post',
        path: '/post',
        channel: currentChannel?.service || null,
      })
    }
  }, [currentPost])

  useEffect(() => {
    if (!channels?.length) return

    const channelsChanged =
      // @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
      currentChannel && !channels.find((el) => el.id === currentChannel.id)

    if (channelsChanged || !currentChannel) {
      onSelectChannel(channels[0].id)
    }
  }, [channels])

  const onSubmitDismissWarning = useCallback((dontShowAgain: boolean) => {
    if (dontShowAgain) {
      hideMarkAsReadModal()
    }
  }, [])

  const onSelectChannel = useCallback(
    (channelId: any) => {
      // @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
      const channel = channels.find((el) => el.id === channelId)

      if (!channel) return

      history.push(`/${channel?.id}`)

      onClearFilter()
      mutateCurrentChannel(channel)
      trackPostsLoaded(channel)
      trackChannelSelected(channel)
    },
    [channels],
  )

  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
  const onReloadPage = useCallback(() => {
    window.location.reload()
  })

  const channelDisconnected = currentChannel?.isDisconnected

  return (
    <>
      <SidebarWrapper>
        <SidebarHeader>
          <ChannelSelector
            channels={channels}
            selected={currentChannel}
            onSelect={onSelectChannel}
          />
          {channelDisconnected ? (
            <RefreshButton service={currentChannel.service} />
          ) : (
            <ChannelCounters channel={currentChannel} />
          )}
        </SidebarHeader>
        {channelDisconnected && (
          <SidebarMessage>
            To resume engaging with comments you will need to refresh
            <br />
            {/* @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message */}
            your {SERVICE_DEFAULTS[currentChannel.service].label} account's
            connection.
          </SidebarMessage>
        )}
        <SidebarContent>
          {error ? (
            <CTABackground
              title="Whoops! Something went wrong."
              subtitle="If this problem persists, please contact support."
              continueLabel="Refresh The Page"
              onContinue={onReloadPage}
            />
          ) : (
            <PostGrid channel={currentChannel} />
          )}

          {channelDisconnected && <Blocker />}
        </SidebarContent>
      </SidebarWrapper>
      <ContentWrapper>
        <Post
          postId={currentPost ? currentPost.id : null}
          disabled={channelDisconnected}
          error={error}
          showDismissWarning={
            userSettings ? userSettings.showMarkAsReadWarningModal : true
          }
          onDismissWarningSubmit={onSubmitDismissWarning}
        />
        <FloatingMenu />
      </ContentWrapper>
    </>
  )
}

export default withRealtime(PostPage)
